// 此文件由构建脚本自动生成，请勿手动修改
export const APP_VERSION = '1.2.21'
